import React from "react";
import { Navigate, useLocation, Route } from "react-router-dom";
import AdminFooter from '../NSFM/Common/AdminFooter';
import AdminHeaderNFSM from '../NSFM/Common/AdminHeader'; 
import AdminSideBarNFSM from '../NSFM/Common/AdminSideBar';

const ProtectedRoute = ({ children }) => {
  // const user = useSelector((state) => state.user);
  let location = useLocation();


  if (!sessionStorage.getItem("user")) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return (
    <>
      {window.location.href.includes("access") ? (
        children
      ) : (
        <>
         
          <AdminHeaderNFSM />
          <AdminSideBarNFSM />
         
          {children}
          <AdminFooter />
        </>
      )}
    </>
  );
};

export default ProtectedRoute;
